var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('success',{attrs:{"title":"提交成功","show-bottom-close-btn":false}},[_c('p',{staticClass:"result-info"},[_vm._v(_vm._s(_vm.statusTxt))])])}
var staticRenderFns = []

export { render, staticRenderFns }